import { createSelector } from '@ngrx/store';
import { getOrdersAndProductsComponentsState } from '@ordersnproducts/modules/shared/reducers/index';
import {
    getJobsiteSelected,
    getSelectedLocationJobsite,
} from '@ordersnproducts/modules/order-builder/reducers';
import { getOrderSelectedDetail } from '@ordersnproducts/modules/new-repeat-order/selectors/order-selected-detail.selector';
import { getSelectedExperienceModify } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/selectors';

export const getReceivingPersonState = createSelector(getOrdersAndProductsComponentsState, state => {
    return state && state.receivingPersons;
});

export const getReceivingPersonEntities = createSelector(getReceivingPersonState, state => {
    return state.receivingPersons;
});

export const getReceivingPersonCreateFormVisible = createSelector(getReceivingPersonState, state => {
    return state.createFormVisible;
});

export const getSelectedReceivingPerson = createSelector(getReceivingPersonState, state => {
    return state && state.selected;
});
export const getReceivingPersonDefaultEmail = createSelector(getReceivingPersonState, state => {
    return state.defaultEmail;
});

/**
 * Get the jobsite id and code from various store locations
*/
export const getValidJobsiteIdAndCode = createSelector(
    getJobsiteSelected,
    getOrderSelectedDetail,
    getSelectedLocationJobsite,
    getSelectedExperienceModify,
    (orderBuilderJobsite, newRepeatOrderDetail, orderBuilderLocationJobsite, newModifyOrderJobsite) => {
        if (orderBuilderJobsite && orderBuilderJobsite.shipmentLocationId) {
            return {
                id: orderBuilderJobsite.shipmentLocationId,
                code: orderBuilderJobsite.shipmentLocationCode,
            };
        } else if (newRepeatOrderDetail && newRepeatOrderDetail.jobsite && newRepeatOrderDetail.jobsite.jobsiteId) {
            return {
                id: newRepeatOrderDetail.jobsite.jobsiteId,
                code: newRepeatOrderDetail.jobsite.jobsiteCode,
            };
        } else if (orderBuilderLocationJobsite && orderBuilderLocationJobsite.jobsiteId) {
            return {
                id: orderBuilderLocationJobsite.jobsiteId,
                code: orderBuilderLocationJobsite.jobsiteCode,
            };
        } else if (newModifyOrderJobsite && newModifyOrderJobsite.selectedJobsite && newModifyOrderJobsite.selectedJobsite.jobsiteId) {
            return {
                id: newModifyOrderJobsite.selectedJobsite.jobsiteId,
                code: newModifyOrderJobsite.selectedJobsite.jobsiteCode,
            };
        }
        return null;
    },
);
export const getContactDeleteStatus = createSelector(
    getReceivingPersonState,
    (state) => state.contactDeleteStatus,
  );
